export const METHODS = [
    'GET','POST','PUT','DELETE','HEAD'
]